export const ASSETS = {
  "logos": {
    "splash": {
      "path": "https://ucarecdn.com/dac37dfb-d2a9-4b0b-bf04-c86978ed718c/graph.svg",
      "width": 300,
      "height": 300
    }
  },
  "icons": {
    "coffee": {
      "path": "https://volter-production-assets-upload.s3.amazonaws.com/161fe5c4cc5e4ef1a10002f73ee9c931/cfbb7cf728114a8080607825339d5e09/preview/assets/icons/coffee.svg",
      "height": 32,
      "transparent": true,
      "width": 32
    },
    "coins": {
      "path": "https://volter-production-assets-upload.s3.amazonaws.com/161fe5c4cc5e4ef1a10002f73ee9c931/cfbb7cf728114a8080607825339d5e09/preview/assets/icons/coins.svg",
      "height": 24,
      "transparent": true,
      "width": 24
    },
    "critic": {
      "path": "https://volter-production-assets-upload.s3.amazonaws.com/161fe5c4cc5e4ef1a10002f73ee9c931/cfbb7cf728114a8080607825339d5e09/preview/assets/icons/critic.png",
      "height": 48,
      "transparent": true,
      "width": 48
    },
    "customer": {
      "path": "https://volter-production-assets-upload.s3.amazonaws.com/161fe5c4cc5e4ef1a10002f73ee9c931/cfbb7cf728114a8080607825339d5e09/preview/assets/icons/customer.png",
      "height": 48,
      "transparent": true,
      "width": 48
    },
    "kid": {
      "path": "https://volter-production-assets-upload.s3.amazonaws.com/161fe5c4cc5e4ef1a10002f73ee9c931/cfbb7cf728114a8080607825339d5e09/preview/assets/icons/kid.png",
      "height": 48,
      "transparent": true,
      "width": 48
    },
    "prestige": {
      "path": "https://volter-production-assets-upload.s3.amazonaws.com/161fe5c4cc5e4ef1a10002f73ee9c931/cfbb7cf728114a8080607825339d5e09/preview/assets/icons/prestige.png",
      "height": 24,
      "transparent": true,
      "width": 24
    },
    "xp": {
      "path": "https://volter-production-assets-upload.s3.amazonaws.com/161fe5c4cc5e4ef1a10002f73ee9c931/cfbb7cf728114a8080607825339d5e09/preview/assets/icons/xp.svg",
      "height": 24,
      "transparent": true,
      "width": 24
    }
  },
  "images": {
    "defaultItem": {
      "path": "https://volter-production-assets-upload.s3.amazonaws.com/161fe5c4cc5e4ef1a10002f73ee9c931/b16cb173cf264554b3ed7e786aeaac1e/preview/assets/default.png",
      "height": 64,
      "transparent": true,
      "width": 64
    },
    "logo": {
      "path": "https://ucarecdn.com/bab900f8-1b69-4625-9642-76d818776412/coffe break logo.png",
      "height": 300,
      "width": 300
    }
  },
  "items": {
    "affogato": {
      "path": "https://ucarecdn.com/5334fc7b-4c44-49ae-85d2-d3b8dad80e98/Affogato.png",
      "height": 300,
      "width": 300
    },
    "almond_cappuccino": {
      "path": "https://volter-production-assets-upload.s3.amazonaws.com/161fe5c4cc5e4ef1a10002f73ee9c931/b16cb173cf264554b3ed7e786aeaac1e/preview/assets/items/almond_cappuccino.png",
      "height": 64,
      "transparent": true,
      "width": 64
    },
    "almond_milk": {
      "path": "https://ucarecdn.com/b3cbdc15-9653-46a8-a3bb-0330eb3df69c/leche almendra.png",
      "height": 300,
      "width": 300
    },
    "americano": {
      "path": "https://ucarecdn.com/1d4569ae-cbfd-4ce7-a4e9-de7c18192f7a/Americano.png",
      "height": 300,
      "width": 300
    },
    "aurora_drip": {
      "path": "https://volter-production-assets-upload.s3.amazonaws.com/161fe5c4cc5e4ef1a10002f73ee9c931/b16cb173cf264554b3ed7e786aeaac1e/preview/assets/items/aurora_drip.png",
      "height": 64,
      "transparent": true,
      "width": 64
    },
    "beans": {
      "path": "https://ucarecdn.com/6889b54a-56cb-42de-b6f0-c2ae037fedb9/cafe.png",
      "height": 300,
      "width": 300
    },
    "black_sesame_latte": {
      "path": "https://volter-production-assets-upload.s3.amazonaws.com/161fe5c4cc5e4ef1a10002f73ee9c931/b16cb173cf264554b3ed7e786aeaac1e/preview/assets/items/black_sesame_latte.png",
      "height": 64,
      "transparent": true,
      "width": 64
    },
    "black_sesame_paste": {
      "path": "https://ucarecdn.com/65db778b-39e0-4d67-9a12-2f6d4207500a/sesamo negro.png",
      "height": 300,
      "width": 300
    },
    "black_sesame_syrup": {
      "path": "https://volter-production-assets-upload.s3.amazonaws.com/161fe5c4cc5e4ef1a10002f73ee9c931/b16cb173cf264554b3ed7e786aeaac1e/preview/assets/items/black_sesame_syrup.png",
      "height": 64,
      "transparent": true,
      "width": 64
    },
    "brew_station_2": {
      "path": "https://ucarecdn.com/635d4630-86e9-4a54-baf0-385eba36c2f6/estacion de cafe.png",
      "height": 300,
      "width": 300
    },
    "cappuccino": {
      "path": "https://ucarecdn.com/a619d79e-9c77-42f7-9888-52a32376f135/Capuccino.png",
      "height": 300,
      "width": 300
    },
    "caramel_cappuccino": {
      "path": "https://volter-production-assets-upload.s3.amazonaws.com/161fe5c4cc5e4ef1a10002f73ee9c931/b16cb173cf264554b3ed7e786aeaac1e/preview/assets/items/caramel_cappuccino.png",
      "height": 64,
      "transparent": true,
      "width": 64
    },
    "caramel_latte": {
      "path": "https://ucarecdn.com/27004fcd-8f5e-49ae-a3ae-710e924acd4f/Caramel Latte.png",
      "height": 300,
      "width": 300
    },
    "caramel_syrup": {
      "path": "https://ucarecdn.com/7b773938-db59-41d6-ace6-6ce08504c7cd/jarabe de caramelo.png",
      "height": 300,
      "width": 300
    },
    "cardamom": {
      "path": "https://ucarecdn.com/fe76733d-e078-4f35-b5a2-e12003699ba6/cardamomo.png",
      "height": 300,
      "width": 300
    },
    "cardamom_espresso": {
      "path": "https://volter-production-assets-upload.s3.amazonaws.com/161fe5c4cc5e4ef1a10002f73ee9c931/b16cb173cf264554b3ed7e786aeaac1e/preview/assets/items/cardamom_espresso.png",
      "height": 64,
      "transparent": true,
      "width": 64
    },
    "chocolate_milk": {
      "path": "https://volter-production-assets-upload.s3.amazonaws.com/161fe5c4cc5e4ef1a10002f73ee9c931/b16cb173cf264554b3ed7e786aeaac1e/preview/assets/items/chocolate_milk.png",
      "height": 64,
      "transparent": true,
      "width": 64
    },
    "chocolate_syrup": {
      "path": "https://ucarecdn.com/cce219ef-1e73-4d34-ab10-7aca820f3cda/jarabe de chocolate.png",
      "height": 300,
      "width": 300
    },
    "cinnamon": {
      "path": "https://ucarecdn.com/1ac31aec-f761-4300-89f8-43bda0e5817a/canela.png",
      "height": 300,
      "width": 300
    },
    "cinnamon_latte": {
      "path": "https://ucarecdn.com/348a67d2-91e5-4a77-ae85-c35f58519379/Cinnamon Latte.png",
      "height": 300,
      "width": 300
    },
    "cinnamon_syrup": {
      "path": "https://volter-production-assets-upload.s3.amazonaws.com/161fe5c4cc5e4ef1a10002f73ee9c931/b16cb173cf264554b3ed7e786aeaac1e/preview/assets/items/cinnamon_syrup.png",
      "height": 64,
      "transparent": true,
      "width": 64
    },
    "cocoa_powder": {
      "path": "https://ucarecdn.com/9d8b9547-7f70-47d9-a182-0733ef1f0530/cacao.png",
      "height": 300,
      "width": 300
    },
    "coconut_milk": {
      "path": "https://ucarecdn.com/693cf888-9a7e-4416-93d7-a9c6cf7f495e/leche coco.png",
      "height": 300,
      "width": 300
    },
    "cold_brew": {
      "path": "https://ucarecdn.com/56c9fdf7-37be-45de-abee-60eaa010741f/Cold Brew.png",
      "height": 300,
      "width": 300
    },
    "cold_brew_latte": {
      "path": "https://volter-production-assets-upload.s3.amazonaws.com/161fe5c4cc5e4ef1a10002f73ee9c931/b16cb173cf264554b3ed7e786aeaac1e/preview/assets/items/cold_brew_latte.png",
      "height": 64,
      "transparent": true,
      "width": 64
    },
    "dirty_matcha": {
      "path": "https://ucarecdn.com/28cd8001-baac-4b65-a6c2-aa545aef35ea/Dirty Matcha.png",
      "height": 300,
      "width": 300
    },
    "espresso": {
      "path": "https://ucarecdn.com/d7e21d75-2906-4d45-985f-0265ca8ee8bc/Espresso 2.png",
      "height": 300,
      "width": 300
    },
    "espresso_con_panna": {
      "path": "https://volter-production-assets-upload.s3.amazonaws.com/161fe5c4cc5e4ef1a10002f73ee9c931/b16cb173cf264554b3ed7e786aeaac1e/preview/assets/items/espresso_con_panna.png",
      "height": 64,
      "transparent": true,
      "width": 64
    },
    "espresso_machine": {
      "path": "https://ucarecdn.com/01fee4ca-0dd7-49c1-9727-e21075b81da5/maquina de espresso.png",
      "height": 300,
      "width": 300
    },
    "flat_white": {
      "path": "https://ucarecdn.com/47bdd883-b3b6-402a-8ae6-90343cd202bf/Flat White.png",
      "height": 300,
      "width": 300
    },
    "grinder": {
      "path": "https://ucarecdn.com/bf0bafad-ed63-4bd4-8886-c74a52d5124b/molinillo.png",
      "height": 300,
      "width": 300
    },
    "ground_coffee": {
      "path": "https://ucarecdn.com/8c8e0481-90f2-440f-9183-81796833e056/cafe molido.png",
      "height": 300,
      "width": 300
    },
    "honey": {
      "path": "https://volter-production-assets-upload.s3.amazonaws.com/161fe5c4cc5e4ef1a10002f73ee9c931/b16cb173cf264554b3ed7e786aeaac1e/preview/assets/items/honey.png",
      "height": 64,
      "transparent": true,
      "width": 64
    },
    "ice": {
      "path": "https://ucarecdn.com/b772ef43-19c5-486a-9a44-1c38bf0056dd/hielo.png",
      "height": 300,
      "width": 300
    },
    "ice_cream": {
      "path": "https://ucarecdn.com/9d53f4e1-2945-4dad-bba6-99acad49082a/helado.png",
      "height": 300,
      "width": 300
    },
    "iced_americano": {
      "path": "https://ucarecdn.com/92168ed3-70f7-4ae0-a473-d6e48072f9ca/Iced Americano.png",
      "height": 300,
      "width": 300
    },
    "iced_cinnamon_latte": {
      "path": "https://volter-production-assets-upload.s3.amazonaws.com/161fe5c4cc5e4ef1a10002f73ee9c931/b16cb173cf264554b3ed7e786aeaac1e/preview/assets/items/iced_cinnamon_latte.png",
      "height": 64,
      "transparent": true,
      "width": 64
    },
    "iced_coconut_latte": {
      "path": "https://volter-production-assets-upload.s3.amazonaws.com/161fe5c4cc5e4ef1a10002f73ee9c931/b16cb173cf264554b3ed7e786aeaac1e/preview/assets/items/iced_coconut_latte.png",
      "height": 64,
      "transparent": true,
      "width": 64
    },
    "iced_espresso": {
      "path": "https://ucarecdn.com/e24431a5-239a-466d-9f25-e5be0e14f1d8/Iced Espresso.png",
      "height": 300,
      "width": 300
    },
    "iced_latte": {
      "path": "https://ucarecdn.com/34c4df9d-7c33-420a-b242-2ac77e9648d3/Iced Latte.png",
      "height": 300,
      "width": 300
    },
    "iced_mocha": {
      "path": "https://ucarecdn.com/b61487ae-832f-4eb4-9fb8-8beb9ef731b9/Iced Moka.png",
      "height": 300,
      "width": 300
    },
    "kettle": {
      "path": "https://ucarecdn.com/e789f369-3b15-4ce8-94eb-fdf590e8a8e8/tetera.png",
      "height": 300,
      "width": 300
    },
    "latte": {
      "path": "https://ucarecdn.com/64ff1d2c-6baf-4bef-92a1-c71fc19b9b70/Latte.png",
      "height": 300,
      "width": 300
    },
    "latte_art_latte": {
      "path": "https://ucarecdn.com/77c6b700-a082-4ec8-ad57-fd87b3774f46/Latte Art Latte.png",
      "height": 300,
      "width": 300
    },
    "masters_harmony": {
      "path": "https://volter-production-assets-upload.s3.amazonaws.com/161fe5c4cc5e4ef1a10002f73ee9c931/b16cb173cf264554b3ed7e786aeaac1e/preview/assets/items/masters_harmony.png",
      "height": 64,
      "transparent": true,
      "width": 64
    },
    "matcha": {
      "path": "https://ucarecdn.com/d6b22d21-4a54-407f-a05f-0f78be18002e/matcha.png",
      "height": 300,
      "width": 300
    },
    "matcha_shot": {
      "path": "https://volter-production-assets-upload.s3.amazonaws.com/161fe5c4cc5e4ef1a10002f73ee9c931/b16cb173cf264554b3ed7e786aeaac1e/preview/assets/items/matcha_shot.png",
      "height": 64,
      "transparent": true,
      "width": 64
    },
    "milk": {
      "path": "https://ucarecdn.com/50b9f161-6d8d-4080-98dc-2d7032c2f8c0/leche.png",
      "height": 300,
      "width": 300
    },
    "milk_foam": {
      "path": "https://ucarecdn.com/64082da4-e78b-475e-8e71-c949200c0597/espuma_de_leche-removebg-preview.png",
      "height": 300,
      "width": 300
    },
    "mocha": {
      "path": "https://ucarecdn.com/f63cf1da-224e-48bb-9c7a-fd4418995699/Moka.png",
      "height": 300,
      "width": 300
    },
    "nitro_cold_brew": {
      "path": "https://volter-production-assets-upload.s3.amazonaws.com/161fe5c4cc5e4ef1a10002f73ee9c931/b16cb173cf264554b3ed7e786aeaac1e/preview/assets/items/nitro_cold_brew.png",
      "height": 64,
      "transparent": true,
      "width": 64
    },
    "nitro_float": {
      "path": "https://volter-production-assets-upload.s3.amazonaws.com/161fe5c4cc5e4ef1a10002f73ee9c931/b16cb173cf264554b3ed7e786aeaac1e/preview/assets/items/nitro_float.png",
      "height": 64,
      "transparent": true,
      "width": 64
    },
    "nitro_ice_float": {
      "path": "https://ucarecdn.com/ebd49df4-3058-4ccf-b3d3-20bed3f00c30/Nitro ice float.png",
      "height": 300,
      "width": 300
    },
    "nitro_tap": {
      "path": "https://ucarecdn.com/b95830de-c9af-42f2-9fed-de242cec3114/grifo_nitro-removebg-preview.png",
      "height": 300,
      "width": 300
    },
    "nutmeg": {
      "path": "https://ucarecdn.com/d6b37ab1-456f-4d15-8b52-176a3e864360/nuex.png",
      "height": 300,
      "width": 300
    },
    "nutmeg_cappuccino": {
      "path": "https://volter-production-assets-upload.s3.amazonaws.com/161fe5c4cc5e4ef1a10002f73ee9c931/b16cb173cf264554b3ed7e786aeaac1e/preview/assets/items/nutmeg_cappuccino.png",
      "height": 64,
      "transparent": true,
      "width": 64
    },
    "oat_milk": {
      "path": "https://ucarecdn.com/1fefc7c4-9060-4a77-8c14-8917f63d148d/leche avena.png",
      "height": 300,
      "width": 300
    },
    "oat_milk_latte": {
      "path": "https://volter-production-assets-upload.s3.amazonaws.com/161fe5c4cc5e4ef1a10002f73ee9c931/b16cb173cf264554b3ed7e786aeaac1e/preview/assets/items/oat_milk_latte.png",
      "height": 64,
      "transparent": true,
      "width": 64
    },
    "peppermint": {
      "path": "https://ucarecdn.com/1f2bc962-3b2e-40b8-bec5-cfff3ba8a90b/menta.png",
      "height": 300,
      "width": 300
    },
    "peppermint_mocha": {
      "path": "https://ucarecdn.com/33277850-79c5-477f-872f-77527f3d7cdd/Peppermint mocha en taza navide\u00f1a.png",
      "height": 300,
      "width": 300
    },
    "phoenix_blend": {
      "path": "https://ucarecdn.com/4fa918e3-98e5-4462-92dd-950eb4366d62/Phoenix blend.png",
      "height": 300,
      "width": 300
    },
    "pumpkin_spice": {
      "path": "https://ucarecdn.com/5521ab72-921b-4ce6-a724-ef0bd2b8caee/especias_de_calabaza-removebg-preview.png",
      "height": 300,
      "width": 300
    },
    "pumpkin_spice_latte": {
      "path": "https://ucarecdn.com/6c53208b-ecd2-4ee5-86a1-8026f43cc797/Pumpkin spice latte.png",
      "height": 300,
      "width": 300
    },
    "pumpkin_spice_syrup": {
      "path": "https://volter-production-assets-upload.s3.amazonaws.com/161fe5c4cc5e4ef1a10002f73ee9c931/b16cb173cf264554b3ed7e786aeaac1e/preview/assets/items/pumpkin_spice_syrup.png",
      "height": 64,
      "transparent": true,
      "width": 64
    },
    "rose_delight": {
      "path": "https://volter-production-assets-upload.s3.amazonaws.com/161fe5c4cc5e4ef1a10002f73ee9c931/b16cb173cf264554b3ed7e786aeaac1e/preview/assets/items/rose_delight.png",
      "height": 64,
      "transparent": true,
      "width": 64
    },
    "rose_latte": {
      "path": "https://ucarecdn.com/56251683-fa3d-43e1-a3b3-3c74b6cbae19/Rose Latte.png",
      "height": 300,
      "width": 300
    },
    "rose_petals": {
      "path": "https://ucarecdn.com/b848362b-19c9-4172-af0a-afa5b3b3046b/petalo de rosa.png",
      "height": 300,
      "width": 300
    },
    "rose_syrup": {
      "path": "https://volter-production-assets-upload.s3.amazonaws.com/161fe5c4cc5e4ef1a10002f73ee9c931/b16cb173cf264554b3ed7e786aeaac1e/preview/assets/items/rose_syrup.png",
      "height": 64,
      "transparent": true,
      "width": 64
    },
    "saffron": {
      "path": "https://ucarecdn.com/12780ff8-4cf7-451c-b3ff-ed58dd3e69de/azafran.png",
      "height": 300,
      "width": 300
    },
    "saffron_latte": {
      "path": "https://volter-production-assets-upload.s3.amazonaws.com/161fe5c4cc5e4ef1a10002f73ee9c931/b16cb173cf264554b3ed7e786aeaac1e/preview/assets/items/saffron_latte.png",
      "height": 64,
      "transparent": true,
      "width": 64
    },
    "shaker": {
      "path": "https://ucarecdn.com/d6ff9a50-8000-4e64-92fd-271940e19b56/espumador.png",
      "height": 300,
      "width": 300
    },
    "simple_syrup": {
      "path": "https://ucarecdn.com/2855a5f9-7d1d-4923-973a-80ec91a4ed37/jarabe.png",
      "height": 300,
      "width": 300
    },
    "spanish_latte": {
      "path": "https://ucarecdn.com/8af100f1-843a-4261-b045-d426243749d0/Spanish Latte.png",
      "height": 300,
      "width": 300
    },
    "steamed_milk": {
      "path": "https://ucarecdn.com/822199ef-f74d-4c93-9ba4-a9a0b056459b/leche vaporizada.png",
      "height": 300,
      "width": 300
    },
    "steamer": {
      "path": "https://ucarecdn.com/c0709133-b788-417b-8a76-9e0f4ed710a9/vaporizador.png",
      "height": 300,
      "width": 300
    },
    "sugar": {
      "path": "https://ucarecdn.com/3c5dddcc-991a-408d-9dc9-1b1bbc2dc431/azucar.png",
      "height": 300,
      "width": 300
    },
    "sundae_affogato": {
      "path": "https://ucarecdn.com/aba80efe-89e9-47a2-879f-25cc44c21c79/Sundae affogato.png",
      "height": 300,
      "width": 300
    },
    "sweet_cold_brew": {
      "path": "https://volter-production-assets-upload.s3.amazonaws.com/161fe5c4cc5e4ef1a10002f73ee9c931/b16cb173cf264554b3ed7e786aeaac1e/preview/assets/items/sweet_cold_brew.png",
      "height": 64,
      "transparent": true,
      "width": 64
    },
    "sweet_espresso": {
      "path": "https://volter-production-assets-upload.s3.amazonaws.com/161fe5c4cc5e4ef1a10002f73ee9c931/b16cb173cf264554b3ed7e786aeaac1e/preview/assets/items/sweet_espresso.png",
      "height": 64,
      "transparent": true,
      "width": 64
    },
    "tahini": {
      "path": "https://ucarecdn.com/75f9d11c-b13b-48d8-b981-4b60db7fd56f/tahini.png",
      "height": 300,
      "width": 300
    },
    "tahini_honey_latte": {
      "path": "https://volter-production-assets-upload.s3.amazonaws.com/161fe5c4cc5e4ef1a10002f73ee9c931/b16cb173cf264554b3ed7e786aeaac1e/preview/assets/items/tahini_honey_latte.png",
      "height": 64,
      "transparent": true,
      "width": 64
    },
    "tahini_honey_syrup": {
      "path": "https://volter-production-assets-upload.s3.amazonaws.com/161fe5c4cc5e4ef1a10002f73ee9c931/b16cb173cf264554b3ed7e786aeaac1e/preview/assets/items/tahini_honey_syrup.png",
      "height": 64,
      "transparent": true,
      "width": 64
    },
    "turkish_coffee": {
      "path": "https://ucarecdn.com/3d395cf9-8177-4493-8484-a3852023051f/Turkish Coffee.png",
      "height": 300,
      "width": 300
    },
    "turkish_grind": {
      "path": "https://volter-production-assets-upload.s3.amazonaws.com/161fe5c4cc5e4ef1a10002f73ee9c931/b16cb173cf264554b3ed7e786aeaac1e/preview/assets/items/turkish_grind.png",
      "height": 64,
      "transparent": true,
      "width": 64
    },
    "turkish_grinder": {
      "path": "https://ucarecdn.com/a49e9453-b4b6-47d7-bb13-a35a2583e0d9/molinillo.png",
      "height": 300,
      "width": 300
    },
    "ube": {
      "path": "https://ucarecdn.com/323d0324-a2aa-4141-8f79-b3038c8f121d/ube-removebg-preview.png",
      "height": 300,
      "width": 300
    },
    "ube_latte": {
      "path": "https://volter-production-assets-upload.s3.amazonaws.com/161fe5c4cc5e4ef1a10002f73ee9c931/b16cb173cf264554b3ed7e786aeaac1e/preview/assets/items/ube_latte.png",
      "height": 64,
      "transparent": true,
      "width": 64
    },
    "vanilla": {
      "path": "https://ucarecdn.com/15d26154-39e8-4863-a60b-8d0d332b2b81/vainilla.png",
      "height": 300,
      "width": 300
    },
    "vanilla_latte": {
      "path": "https://ucarecdn.com/35699c6f-119c-4e85-a3ca-470a92d3623d/Vanilla Latte.png",
      "height": 300,
      "width": 300
    },
    "vanilla_nitro": {
      "path": "https://volter-production-assets-upload.s3.amazonaws.com/161fe5c4cc5e4ef1a10002f73ee9c931/b16cb173cf264554b3ed7e786aeaac1e/preview/assets/items/vanilla_nitro.png",
      "height": 64,
      "transparent": true,
      "width": 64
    },
    "vanilla_syrup": {
      "path": "https://volter-production-assets-upload.s3.amazonaws.com/161fe5c4cc5e4ef1a10002f73ee9c931/b16cb173cf264554b3ed7e786aeaac1e/preview/assets/items/vanilla_syrup.png",
      "height": 64,
      "transparent": true,
      "width": 64
    },
    "water": {
      "path": "https://ucarecdn.com/c664a0b0-3099-4c86-9d69-d0cf0b96126c/agua.png",
      "height": 300,
      "width": 300
    },
    "whipped_cream": {
      "path": "https://ucarecdn.com/d4992503-58b1-44cd-a903-d1521c157751/crema batida.png",
      "height": 300,
      "width": 300
    }
  },
  "music": {
    "cafeAmbient": {
      "path": "https://volter-production-assets-upload.s3.amazonaws.com/161fe5c4cc5e4ef1a10002f73ee9c931/cfbb7cf728114a8080607825339d5e09/preview/assets/music/cafe-ambient.ogg"
    }
  },
  "sfx": {
    "brew": {
      "path": "https://volter-production-assets-upload.s3.amazonaws.com/161fe5c4cc5e4ef1a10002f73ee9c931/cfbb7cf728114a8080607825339d5e09/preview/assets/sfx/brew.ogg"
    },
    "cashRegister": {
      "path": "https://volter-production-assets-upload.s3.amazonaws.com/161fe5c4cc5e4ef1a10002f73ee9c931/cfbb7cf728114a8080607825339d5e09/preview/assets/sfx/cash-register.ogg"
    },
    "click": {
      "path": "https://volter-production-assets-upload.s3.amazonaws.com/161fe5c4cc5e4ef1a10002f73ee9c931/cfbb7cf728114a8080607825339d5e09/preview/assets/sfx/click.ogg"
    },
    "discovery": {
      "path": "https://volter-production-assets-upload.s3.amazonaws.com/161fe5c4cc5e4ef1a10002f73ee9c931/cfbb7cf728114a8080607825339d5e09/preview/assets/sfx/discovery.ogg"
    },
    "serve": {
      "path": "https://volter-production-assets-upload.s3.amazonaws.com/161fe5c4cc5e4ef1a10002f73ee9c931/cfbb7cf728114a8080607825339d5e09/preview/assets/sfx/serve.ogg"
    }
  },
  "ui": {
    "brewButton": {
      "path": "https://volter-production-assets-upload.s3.amazonaws.com/161fe5c4cc5e4ef1a10002f73ee9c931/cfbb7cf728114a8080607825339d5e09/preview/assets/ui/brew-button.svg",
      "height": 60,
      "transparent": true,
      "width": 200
    },
    "ghostHand": {
      "path": "https://volter-production-assets-upload.s3.amazonaws.com/161fe5c4cc5e4ef1a10002f73ee9c931/cfbb7cf728114a8080607825339d5e09/preview/assets/ui/ghost-hand.png",
      "height": 64,
      "transparent": true,
      "width": 64
    },
    "rotateDevice": {
      "path": "https://volter-production-assets-upload.s3.amazonaws.com/161fe5c4cc5e4ef1a10002f73ee9c931/5d34345b2c8449398f6d38369d39c49a/preview/assets/ui/rotateDevice.svg",
      "width": 96,
      "height": 96,
      "transparent": true
    },
    "slotEmpty": {
      "path": "https://volter-production-assets-upload.s3.amazonaws.com/161fe5c4cc5e4ef1a10002f73ee9c931/cfbb7cf728114a8080607825339d5e09/preview/assets/ui/slot-empty.svg",
      "height": 120,
      "transparent": true,
      "width": 120
    },
    "slotFilled": {
      "path": "https://volter-production-assets-upload.s3.amazonaws.com/161fe5c4cc5e4ef1a10002f73ee9c931/cfbb7cf728114a8080607825339d5e09/preview/assets/ui/slot-filled.svg",
      "height": 120,
      "transparent": true,
      "width": 120
    }
  }
}
